export default __webpack_public_path__ + "videos/2a2b4cef80eb1c4b94a37e6b120c0ce2.mp4";